import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { setSubmissionStage } from 'actions';
import { submissionStages } from 'common/forms/submissionStages';

export const FORM_CERTIFY_REQUEST = 'FORM_CERTIFY_REQUEST';
export const FORM_CERTIFY_SUCCESS = 'FORM_CERTIFY_SUCCESS';
export const FORM_CERTIFY_FAILURE = 'FORM_CERTIFY_FAILURE';
export const FORM_CERTIFY_RESET = 'FORM_CERTIFY_RESET';

export function resetCertifyState() {
  return {
    type: FORM_CERTIFY_RESET
  };
}

function request() {
  return {
    type: FORM_CERTIFY_REQUEST
  };
}

function receive(workflowState) {
  return {
    type: FORM_CERTIFY_SUCCESS,
    workflowState
  };
}

function reject() {
  return {
    type: FORM_CERTIFY_FAILURE
  };
}

export function certifyForm(id) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .certify(id)
      .then((response) => {
        dispatch(receive(response.data.data));
        dispatch(setSubmissionStage(submissionStages.Signing));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true, false));
        }
      });

    return promise();
  };
}

export function certifyFormGroup(id) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .certifyFormGroup(id)
      .then((response) => {
        dispatch(receive(response.data.data));
        dispatch(setSubmissionStage(submissionStages.Signing));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true, false));
        }
      });

    return promise();
  };
}
